import { useEffect, useState } from "react"
import ReactMarkdown from "react-markdown"
import { useFetch } from "../../../hooks/useFetch"
import { API_ENDPOINTS, POPULATE_PARAMS } from "../../../config/constants"
import Loading from '../../../components/common/Loading'
import ErrorMessage from '../../../components/common/ErrorMessage'
import { getMediaURL } from "../../../utils/helpers"
const President = () => {


    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const t = setTimeout(() => setVisible(true), 80);
        return () => clearTimeout(t);
    }, []);

    const { data: president, loading, error } = useFetch(
        API_ENDPOINTS.PRESIDENT,
        POPULATE_PARAMS.ONE_WITH_IMAGES
    );



    if (loading) return <Loading />;
    if (error) return <ErrorMessage message={error} />;
    const dir = president;
    const imageUrl = getMediaURL(dir.cover) || '/placeholder_hor.jpg';



    return (
        <div className="w-full min-h-screen bg-white">
            <div className="max-w-2xl mx-auto px-4 pt-20 pb-28">

                {/* ── PHOTO ── */}
                <div className="flex flex-col items-center">
                    <div
                        style={{
                            opacity: visible ? 1 : 0,
                            transform: visible ? "translateY(0)" : "translateY(20px)",
                            transition: "opacity 0.7s ease, transform 0.7s ease",
                        }}
                        className="relative"
                    >
                        {/* Soft glow ring behind photo */}
                        <div className="absolute inset-0 rounded-full bg-blue-100 scale-110 blur-md opacity-70" />
                        <img
                            src={imageUrl}
                            alt={dir.name}
                            onError={(e) => {
                                e.target.src = "https://placehold.co/240x240/1e3a5f/ffffff?text=Foto%C4%9Fraf";
                            }}
                            className="relative w-52 h-52 rounded-full object-cover border-4 border-white shadow-xl"
                        />
                    </div>

                    {/* Name */}
                    <h1
                        className="mt-7 text-2xl font-serif font-bold text-blue-900 text-center"
                        style={{
                            opacity: visible ? 1 : 0,
                            transform: visible ? "translateY(0)" : "translateY(12px)",
                            transition: "opacity 0.7s ease 160ms, transform 0.7s ease 160ms",
                        }}
                    >
                        {dir.name}
                    </h1>

                    {/* Title */}
                    <p
                        className="mt-1 text-xs tracking-[0.22em] uppercase text-blue-600/70 font-semibold"
                        style={{
                            opacity: visible ? 1 : 0,
                            transition: "opacity 0.7s ease 300ms",
                        }}
                    >
                        YÖNETİM KURULU BAŞKANI
                    </p>

                    {/* Divider */}
                    <div
                        className="mt-8 w-10 h-px bg-blue-900/20"
                        style={{
                            opacity: visible ? 1 : 0,
                            transition: "opacity 0.7s ease 420ms",
                        }}
                    />
                </div>

                {/* ── MARKDOWN ── */}
                <div
                    className="mt-10 prose prose-blue max-w-none"
                    style={{
                        opacity: visible ? 1 : 0,
                        transform: visible ? "translateY(0)" : "translateY(16px)",
                        transition: "opacity 0.8s ease 500ms, transform 0.8s ease 500ms",
                    }}
                >
                    <ReactMarkdown>{dir.description}</ReactMarkdown>
                </div>

            </div>
        </div>
    );
};

export default President;